import { createSlice } from '@reduxjs/toolkit';

type EncryptionSliceInitial = {
    localSavedPassword :  string,
    refreshToken: string
}

const initialState : EncryptionSliceInitial = {
    localSavedPassword : '',
    refreshToken : ''
};

const Appstatus = createSlice({
    name: 'Encryption',
    initialState,
    reducers: {
        setLocalPassword: (state, action) => state.localSavedPassword = action.payload,
        setRefreshToken: (state, action) => state.refreshToken = action.payload
    }
});

// EXPORT DEFAULT
export const { 
    setLocalPassword,
    setRefreshToken
} = Appstatus.actions

export default Appstatus.reducer;